export enum SuggestedExchangeEventType {
  VARIANT_EXCHANGE = "variant-exchange",
  EXCHANGE_GROUPS = "exchange-groups",
  RECOMMENDED_EXCHANGE = "recommended-exchange",
  NO_EXCHANGE = "no-exchange",
}

export interface SuggestedExchangeResult {
  exchangedItem: boolean;
  exchangeType: SuggestedExchangeEventType;
  additionalData: any;
}
